import styled from 'styled-components';

import Button from '~/components/Button';
import IconButton from '~/components/IconButton';
import { media } from '~/styles/mixins';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 90%;
	max-width: 800px;
	margin: 30px auto 0;
	${media.medium`
		margin-top: 60px;
	`};
`;

export const FullDuck = styled.img`
	display: block;
	width: 200px;
	height: 150.23px;
	margin-top: 32px;

	${media.small`
		margin-right: 32px;
		margin-top: 0;
	`};
`;

export const Community = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 48px;
	margin-bottom: 48px;
	border: solid 1px ${({ theme }) => theme.colors.grey[200]};
	border-radius: ${({ theme }) => theme.shape.largeBorderRadius};

	${media.small`
		margin-bottom: 64px;
	`};
`;

export const ContactInfo = styled.div`
	display: flex;
	flex-direction: column-reverse;
	text-align: center;
	${media.small`
		flex-direction: row;
		text-align: left;
	`};
`;

// Make the button look like the Zendesk widget button. Large radius will make the radius 50% of
// the height
export const ChatButton = styled(Button)`
	border-radius: 999px;
`;

export const SocialIconRow = styled.div`
	display: flex;
	align-items: center;
	margin-top: 8px;
`;

export const SocialButton = styled(IconButton)`
	margin: 0 6px;
`;
